<div
    class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-gray-200/50 backdrop-blur-sm border border-gray-100/50 transform transition-all duration-300 ease-out hover:shadow-3xl hover:scale-[1.02]"
>
    <div class="p-5">
        <div class="flex items-start justify-between gap-3">
            <div class="flex items-start gap-3 flex-1 min-w-0">
                <div class="flex-shrink-0 mt-0.5">
                    <div
                        class="w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold"
                        [ngClass]="{
                            'bg-red-100 text-red-600': options.type === 'error',
                            'bg-green-100 text-green-600':
                                options.type === 'success',
                            'bg-primary-100 text-primary-600': options.type === 'info'
                        }"
                    >
                        <span *ngIf="options.type === 'error'">!</span>
                        <span *ngIf="options.type === 'success'">✓</span>
                        <span *ngIf="options.type === 'info'">i</span>
                    </div>
                </div>
                <div class="flex-1 min-w-0">
                    <h3
                        class="text-sm font-semibold text-gray-900 leading-5"
                        [ngClass]="{
                            'text-red-900': options.type === 'error',
                            'text-green-900': options.type === 'success',
                            'text-primary-900': options.type === 'info'
                        }"
                    >
                        {{ options.title }}
                    </h3>
                    <div class="mt-1">
                        <ng-container *ngIf="options.message">
                            <p class="text-sm text-gray-600 leading-5">
                                {{ options.message }}
                            </p>
                        </ng-container>
                        <ng-container *ngIf="options.templateRef">
                            <ng-container
                                *ngTemplateOutlet="
                                    options.templateRef;
                                    context: options.templateContext
                                "
                            ></ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
            <button
                type="button"
                class="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all duration-200 ease-out focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
                data-dismiss="toast"
                aria-label="Close"
                (click)="close.next()"
            >
                ×
            </button>
        </div>
    </div>
    <div
        class="h-1 bg-gradient-to-r transition-all duration-500 ease-out"
        [ngClass]="{
            'from-red-500 to-red-600': options.type === 'error',
            'from-green-500 to-green-600': options.type === 'success',
            'from-primary-500 to-primary-600': options.type === 'info'
        }"
    ></div>
</div>
